import React from "react";
import stylesCommon from "@/styles/detail/DetailBookingSidebar/DetailBookingConfigurator.module.scss";
import { InfoType } from "@/models/common/enums";
import PackageDetailAddToCartBoxInfo from "../../PackageDetailAddToCartBoxInfo";

const FinalPriceSectionDetail = ({
    price,
    toggleInfoModal,
    showPrice = true,
}: {
    price: number;
    toggleInfoModal: (info: InfoType) => void;
    showPrice?: boolean;
}) => {
    return (
        <>
            <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
                <h3 className={stylesCommon.configuratorTitle}>
                    Your package price
                </h3>
            </div>
            <PackageDetailAddToCartBoxInfo
                showPrice={showPrice}
                price={price}
                onClickInfo={() => toggleInfoModal(InfoType.PRICE)}
            />
        </>
    );
};

export default FinalPriceSectionDetail;
